import { makeStyles } from 'tss-react/mui';

export const useBreadcrumbsStyles = makeStyles<boolean>()(
  (theme, hasBreadcrumbs) => ({
    accountStatus: {
      marginLeft: hasBreadcrumbs ? theme.spacing(3) : undefined,
      marginRight: 'auto',
    },
  }),
);
